// Classement général de championnat — colonnes et calcul auto (3 pts V, 1 N, 0 D)
export const LEAGUE_COLUMNS = [
  { key: "matches_played", label: "M" },
  { key: "wins", label: "V" },
  { key: "draws", label: "N" },
  { key: "losses", label: "D" },
  { key: "goals_for", label: "BP" },
  { key: "goals_against", label: "BC" },
  { key: "goal_diff", label: "+/-" },
  { key: "points", label: "PTS" },
];

const zero = () => ({
  matches_played: 0,
  wins: 0,
  draws: 0,
  losses: 0,
  goals_for: 0,
  goals_against: 0,
  goal_diff: 0,
  points: 0,
});

export const isPlayedMatch = (m) =>
  m.home_id &&
  m.away_id &&
  m.home_id !== m.away_id &&
  m.home_score !== null &&
  m.home_score !== "" &&
  m.home_score !== undefined &&
  m.away_score !== null &&
  m.away_score !== "" &&
  m.away_score !== undefined;

export const computeLeagueStandings = (teams, matches) => {
  const stats = {};
  teams.forEach((t) => {
    stats[t.id] = zero();
  });
  (matches || []).forEach((m) => {
    if (!isPlayedMatch(m)) return;
    const h = stats[m.home_id];
    const a = stats[m.away_id];
    if (!h || !a) return;
    const hs = Number(m.home_score) || 0;
    const as = Number(m.away_score) || 0;
    h.matches_played += 1;
    a.matches_played += 1;
    h.goals_for += hs;
    h.goals_against += as;
    a.goals_for += as;
    a.goals_against += hs;
    if (hs > as) {
      h.wins += 1;
      h.points += 3;
      a.losses += 1;
    } else if (hs < as) {
      a.wins += 1;
      a.points += 3;
      h.losses += 1;
    } else {
      h.draws += 1;
      a.draws += 1;
      h.points += 1;
      a.points += 1;
    }
  });
  Object.values(stats).forEach((s) => {
    s.goal_diff = s.goals_for - s.goals_against;
  });
  return teams.map((t) => ({ ...t, ...stats[t.id], points_manual: false }));
};

export const sortLeagueTeams = (a, b) =>
  (b.points || 0) - (a.points || 0) ||
  (b.goal_diff || 0) - (a.goal_diff || 0) ||
  (b.goals_for || 0) - (a.goals_for || 0) ||
  (a.name || "").localeCompare(b.name || "");

// Départage configurable : "diff" (défaut) = PTS > +/- > BP ; "goals" = PTS > BP > +/-
export const leagueSorter = (tiebreaker) =>
  tiebreaker === "goals"
    ? (a, b) =>
        (b.points || 0) - (a.points || 0) ||
        (b.goals_for || 0) - (a.goals_for || 0) ||
        (b.goal_diff || 0) - (a.goal_diff || 0) ||
        (a.name || "").localeCompare(b.name || "")
    : sortLeagueTeams;
